import React from "react";

// Decorative slowly-spinning shield watermark, built from the Iron Gate
// crest. Purely ambient -- aria-hidden, non-interactive.
const SpinningShield = ({
  size = 200,
  opacity = 0.08,
  duration = 40,
  reverse = false,
  centered = false,
  className = "",
  style = {},
}) => (
  <img
    src="/shield-square.png"
    alt=""
    aria-hidden="true"
    draggable="false"
    className={`${centered ? "animate-spin-slow-centered" : "animate-spin-slow"} ${
      reverse ? "spin-reverse" : ""
    } pointer-events-none select-none ${className}`}
    style={{
      width: size,
      height: size,
      opacity,
      animationDuration: `${duration}s`,
      ...style,
    }}
  />
);

export default SpinningShield;
